


import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import SiteHeader from "./components/SiteHeader";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Restaurant from "./pages/Restaurant";
import Gallery from "./pages/Gallery";
import RoomDetails from "./pages/RoomDetails";
import Rooms from "./components/Rooms";
import Contact from "./components/Contact";
import Reviews from "./pages/Reviews";
import CustomerDetails from "./components/CustomerDetails";
import CustomerReviews from "./components/CustomerReviews";
import PaymentSuccess from "./components/PaymentSuccess";
import Login from "./components/Login";
import AdminHeader from "./components/AdminHeader";
import AdminHome from "./components/AdminHome";
import AdminDashboard from "./pages/AdminDashboard";
import AdminInventory from "./pages/AdminInventory";

import AdminRates from "./pages/AdminRates";
import Invoice from "./components/Invoice";
import GrcForm from "./components/GrcForm";
import CancelBooking from "./components/CancelBooking";
import ProtectedRoute from "./components/ProtectedRoute";
import { RoomProvider } from "./context/RoomContext";
import { RoomSelectionProvider } from "./context/RoomSelectionContext";
import { DashboardProvider } from "./context/DashboardContext";

const App = () => {
  return (
    <RoomProvider>
      <RoomSelectionProvider>
        <DashboardProvider>
          <Router>
            <ConditionalHeaders />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/restaurant" element={<Restaurant />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/room/:id" element={<RoomDetails />} />
              <Route path="/rooms" element={<Rooms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/customerdetails" element={<CustomerDetails />} />
              <Route path="/customerreviews" element={<CustomerReviews />} />
              <Route path="/paymentsuccess" element={<PaymentSuccess />} />
              <Route path="/login" element={<Login />} />
              <Route path="/adminheader" element={<ProtectedRoute><AdminHeader /></ProtectedRoute>} />
              <Route path="/adminhome" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
              <Route path="/admindashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admininventory" element={<ProtectedRoute><AdminInventory /></ProtectedRoute>} />
              <Route path="/adminrates" element={<ProtectedRoute><AdminRates /></ProtectedRoute>} />
              <Route path="/invoice" element={<Invoice />} />
              <Route path="/grc" element={<GrcForm />} />
              <Route path="/cancel-booking/:bookingId" element={<CancelBooking />} />
            </Routes>
            <ConditionalFooter />
          </Router>
        </DashboardProvider>
      </RoomSelectionProvider>
    </RoomProvider>
  );
};
const isAdminPath = (pathname) =>
  pathname.startsWith("/login") ||
  pathname.startsWith("/admin") ||
  pathname.startsWith("/invoice") ||
  pathname.startsWith("/grc") ||
  pathname.startsWith("/customerreviews") ||
  pathname.startsWith("/cancel-booking");

const ConditionalHeaders = () => {
  const location = useLocation();

  if (isAdminPath(location.pathname)) {
    return null;
  }

  return <SiteHeader />;
};

const ConditionalFooter = () => {
  const location = useLocation();

  if (isAdminPath(location.pathname)) {
    return null;
  }

  return <Footer />;
};

export default App;
